import _extends from "@babel/runtime-corejs3/helpers/extends";
import React from 'react';
import cx from 'classnames';
export const GenericSelectControlControl = ({
  children,
  isFocused,
  innerRef,
  innerProps,
  className,
  selectProps: {
    genericSelectStyles,
    invalid
  }
}) => {
  const controlClasses = cx(genericSelectStyles.control, {
    [genericSelectStyles.controlFocused]: isFocused && !invalid,
    invalid,
    [genericSelectStyles.focusedInvalid]: isFocused && invalid
  }, className);
  return React.createElement("div", _extends({
    ref: innerRef,
    className: controlClasses
  }, innerProps), children);
};
GenericSelectControlControl.__docgenInfo = {
  componentName: "GenericSelectControlControl",
  packageName: "@jutro/components",
  description: "",
  displayName: "GenericSelectControlControl",
  methods: [],
  actualName: "GenericSelectControlControl"
};